"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tersifyAcorn = void 0;
var acorn_1 = require("acorn");
var trim_js_1 = require("../trim.js");
var isHigherBinaryOperatorOrder_js_1 = require("./isHigherBinaryOperatorOrder.js");
function tersifyAcorn(context, value, length) {
    var fnStr = getFunctionString(value);
    var node = (0, acorn_1.parseExpressionAt)("(".concat(fnStr, ")"), 0, { ecmaVersion: 2020 });
    var result = tersifyAcornNode(context, node, length);
    return result;
}
exports.tersifyAcorn = tersifyAcorn;
function getFunctionString(value) {
    var fnStr = value.toString();
    var isAsync = fnStr.startsWith('async ');
    var subject = isAsync ? fnStr.slice('async '.length) : fnStr;
    var matches = /^([^\s\\)]+)\s?\(/.exec(subject);
    return matches && (matches[1] !== 'function' && matches[1] !== 'function*') ?
        "".concat(isAsync ? 'async ' : '', "function ").concat(fnStr) :
        fnStr;
}
function tersifyAcornNode(context, node, length) {
    if (!node)
        return '';
    switch (node.type) {
        case 'Identifier':
            return tersifyIdentifierNode(context, node, length);
        case 'Literal':
            return tersifyLiteralNode(context, node, length);
        case 'AssignmentPattern':
            return tersifyAssignmentPatternNode(context, node, length);
        case 'RestElement':
        case 'SpreadElement':
            return tersifyRestElementNode(context, node, length);
        case 'ArrowFunctionExpression':
            return tersifyArrowExpressionNode(context, node, length);
        case 'ExpressionStatement':
            return tersifyExpressionStatementNode(context, node, length);
        case 'CallExpression':
            return tersifyCallExpressionNode(context, node, length);
        case 'MemberExpression':
            return tersifyMemberExpressionNode(context, node, length);
        case 'FunctionDeclaration':
        case 'FunctionExpression':
            return tersifyFunctionExpressionNode(context, node, length);
        case 'BlockStatement':
        case 'ClassBody':
            return tersifyBlockStatementNode(context, node, length);
        case 'ReturnStatement':
            return tersifyReturnStatementNode(context, node, length);
        case 'VariableDeclaration':
            return tersifyVariableDeclarationNode(context, node, length);
        case 'VariableDeclarator':
            return tersifyVariableDeclaratorNode(context, node, length);
        case 'NewExpression':
            return tersifyNewExpressionNode(context, node, length);
        case 'BinaryExpression':
        case 'LogicalExpression':
            return tersifyBinaryExpressionNode(context, node, length);
        case 'ConditionalExpression':
            return tersifyConditionalExpressionNode(context, node, length);
        case 'UnaryExpression':
            return tersifyUnaryExpressionNode(context, node, length);
        case 'UpdateExpression':
            return tersifyUpdateExpressionNode(context, node, length);
        case 'IfStatement':
            return tersifyIfStatementNode(context, node, length);
        case 'WhileStatement':
            return tersifyWhileStatementNode(context, node, length);
        case 'AssignmentExpression':
            return tersifyAssignmentExpressionNode(context, node, length);
        case 'DoWhileStatement':
            return tersifyDoWhileStatementNode(context, node, length);
        case 'ForStatement':
            return tersifyForStatementNode(context, node, length);
        case 'BreakStatement':
            return tersifyBreakStatementNode(context, node, length);
        case 'LabeledStatement':
            return tersifyLabeledStatementNode(context, node, length);
        case 'ContinueStatement':
            return tersifyContinueStatementNode(context, node, length);
        case 'SwitchStatement':
            return tersifySwitchStatementNode(context, node, length);
        case 'SwitchCase':
            return tersifySwitchCaseNode(context, node, length);
        case 'ForInStatement':
            return tersifyForInStatementNode(context, node, length);
        case 'ForOfStatement':
            return tersifyForOfStatementNode(context, node, length);
        case 'ObjectExpression':
            return tersifyObjectExpressionNode(context, node, length);
        case 'Property':
            return tersifyPropertyNode(context, node, length);
        case 'YieldExpression':
            return tersifyYieldExpressionNode(context, node, length);
        case 'AwaitExpression':
            return tersifyAwaitExpressionNode(context, node, length);
        case 'ArrayExpression':
            return tersifyArrayExpressionNode(context, node, length);
        case 'ThrowStatement':
            return tersifyThrowStatementNode(context, node, length);
        case 'TryStatement':
            return tersifyTryStatementNode(context, node, length);
        case 'CatchClause':
            return tersifyCatchClauseNode(context, node, length);
        case 'ThisExpression':
            return tersifyThisExpression(context, node, length);
        case 'ClassExpression':
            return tersifyClassExpression(context, node, length);
        case 'MethodDefinition':
            return tersifyMethodDefinition(context, node, length);
        case 'ObjectPattern':
            return tersifyObjectPattern(context, node, length);
        case 'SequenceExpression':
            return tersifySequenceExpression(context, node, length);
        case 'TemplateLiteral':
            return tersifyTemplateLiteral(context, node, length);
        case 'TaggedTemplateExpression':
            return tersifyTaggedTemplateExpression(context, node, length);
        case 'ChainExpression':
            return tersifyChainExpression(context, node, length);
        case 'MetaProperty':
            return tersifyMetaProperty(context, node, length);
        // istanbul ignore next
        default:
            return tersifyUnknown(node);
    }
}
// istanbul ignore next
function tersifyUnknown(node) {
    var nodeType = node.type;
    console.warn("tersify received unsupported type: ".concat(nodeType, ". Please open an issue at https://github.com/unional/tersify/issues\nnode detail:\n").concat(JSON.stringify(node, undefined, 2)));
    return "<unsupported: ".concat(nodeType, ">");
}
function tersifyCatchClauseNode(context, node, length) {
    var param = tersifyAcornNode(context, node.param, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "catch".concat(param ? " (".concat(param, ")") : '').concat(body ? " ".concat(body) : '');
}
function tersifyTryStatementNode(context, node, length) {
    var block = tersifyAcornNode(context, node.block, length);
    var handler = tersifyAcornNode(context, node.handler, length);
    var finalizer = tersifyAcornNode(context, node.finalizer, length);
    return "try ".concat(block).concat(handler ? " ".concat(handler) : '').concat(finalizer ? " finally ".concat(finalizer) : '');
}
function tersifyThrowStatementNode(context, node, length) {
    return "throw ".concat(tersifyAcornNode(context, node.argument, length));
}
function tersifyArrayExpressionNode(context, node, length) {
    var elements = node.elements.map(function (e) { return tersifyAcornNode(context, e, length); });
    return (0, trim_js_1.trim)(context, "[".concat(elements.join(', '), "]"), length);
}
function tersifyAwaitExpressionNode(context, node, length) {
    return "await ".concat(tersifyAcornNode(context, node.argument, length));
}
function tersifyYieldExpressionNode(context, node, length) {
    var argument = tersifyAcornNode(context, node.argument, length);
    return "yield ".concat(argument);
}
function tersifyMetaProperty(context, node, length) {
    var meta = tersifyAcornNode(context, node.meta, length);
    return "".concat(meta, ".").concat(tersifyAcornNode(context, node.property, length));
}
function tersifyPropertyNode(context, node, length) {
    var key = tersifyAcornNode(context, node.key, length);
    var valueNode = node.value;
    if (valueNode.type === 'FunctionExpression') {
        var async = valueNode.async ? 'async ' : '';
        var generator = valueNode.generator ? '*' : '';
        var params = tersifyFunctionParams(context, valueNode.params);
        var body = tersifyFunctionBody(context, valueNode.body);
        return "".concat(async).concat(generator).concat(key).concat(params, " ").concat(body);
    }
    if (valueNode.type === 'AssignmentPattern') {
        return tersifyAcornNode(context, valueNode, length);
    }
    var value = tersifyAcornNode(context, valueNode, length);
    if (node.computed) {
        return "[".concat(key, "]: ").concat(value);
    }
    if (key === value) {
        return key;
    }
    return "".concat(key, ": ").concat(value);
}
function tersifyObjectExpressionNode(context, node, length) {
    var properties = node.properties.map(function (p) { return tersifyAcornNode(context, p, length); });
    return "{ ".concat(properties.join(', '), " }");
}
function tersifyForOfStatementNode(context, node, length) {
    var left = tersifyAcornNode(context, node.left, length);
    var right = tersifyAcornNode(context, node.right, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "for (".concat(left, " of ").concat(right, ") ").concat(body);
}
function tersifyForInStatementNode(context, node, length) {
    var left = tersifyAcornNode(context, node.left, length);
    var right = tersifyAcornNode(context, node.right, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "for (".concat(left, " in ").concat(right, ") ").concat(body);
}
function tersifySwitchCaseNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var consequent = node.consequent.map(function (c) { return tersifyAcornNode(context, c, length); });
    if (node.test) {
        return "case ".concat(test, ": ").concat(consequent.join(' '));
    }
    else {
        return "default: ".concat(consequent.join(' '));
    }
}
function tersifySwitchStatementNode(context, node, length) {
    var discriminant = tersifyAcornNode(context, node.discriminant, length);
    var cases = node.cases.map(function (c) { return tersifyAcornNode(context, c, length); });
    return "switch (".concat(discriminant, ") { ").concat(cases.join('; '), " }");
}
function tersifyContinueStatementNode(context, node, length) {
    var label = tersifyAcornNode(context, node.label, length);
    return label ? "continue ".concat(label) : 'continue';
}
function tersifyLabeledStatementNode(context, node, length) {
    var label = tersifyAcornNode(context, node.label, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "".concat(label, ": ").concat(body);
}
function tersifyBreakStatementNode(context, node, length) {
    var label = tersifyAcornNode(context, node.label, length);
    return label ? "break ".concat(label) : 'break';
}
function tersifyForStatementNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var init = tersifyAcornNode(context, node.init, length);
    var update = tersifyAcornNode(context, node.update, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "for (".concat(init, ";").concat(test ? " ".concat(test) : '', ";").concat(update ? " ".concat(update) : '', ") ").concat(body);
}
function tersifyAssignmentExpressionNode(context, node, length) {
    var left = tersifyAcornNode(context, node.left, length);
    var right = tersifyAcornNode(context, node.right, length);
    return "".concat(left, " ").concat(node.operator, " ").concat(right);
}
function tersifyWhileStatementNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var body = tersifyAcornNode(context, node.body, length);
    return "while (".concat(test, ") ").concat(body);
}
function tersifyDoWhileStatementNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var body = tersifyAcornNode(context, node.body, length);
    if (node.body.type === 'BlockStatement')
        return "do ".concat(body, " while (").concat(test, ")");
    else
        return "do ".concat(body, "; while (").concat(test, ")");
}
function tersifyUnaryExpressionNode(context, node, length) {
    if (['void', 'typeof'].indexOf(node.operator) !== -1)
        return "".concat(node.operator, " ").concat(tersifyAcornNode(context, node.argument, length));
    return node.prefix ?
        "".concat(node.operator).concat(tersifyAcornNode(context, node.argument, length)) :
        "".concat(tersifyAcornNode(context, node.argument, length)).concat(node.operator);
}
function tersifyUpdateExpressionNode(context, node, length) {
    return node.prefix ?
        "".concat(node.operator).concat(tersifyAcornNode(context, node.argument, length)) :
        "".concat(tersifyAcornNode(context, node.argument, length)).concat(node.operator);
}
function tersifyConditionalExpressionNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var consequent = tersifyAcornNode(context, node.consequent, length);
    var alternate = tersifyAcornNode(context, node.alternate, length);
    return "".concat(test, " ? ").concat(consequent, " : ").concat(alternate);
}
function tersifyIfStatementNode(context, node, length) {
    var test = tersifyAcornNode(context, node.test, length);
    var consequent = tersifyAcornNode(context, node.consequent, length);
    var alternate = tersifyAcornNode(context, node.alternate, length);
    if (alternate) {
        if (node.consequent.type !== 'BlockStatement') {
            return "if (".concat(test, ") ").concat(consequent, "; else ").concat(alternate);
        }
        else {
            return "if (".concat(test, ") ").concat(consequent, " else ").concat(alternate);
        }
    }
    else
        return "if (".concat(test, ") ").concat(consequent);
}
function tersifyBinaryExpressionNode(context, node, length) {
    if ((node.left.type === 'BinaryExpression' || node.left.type === 'LogicalExpression') && (0, isHigherBinaryOperatorOrder_js_1.isHigherOperatorOrder)(node.operator, node.left.operator)) {
        node.left.needParen = true;
    }
    var left = tersifyAcornNode(context, node.left, length);
    if ((node.right.type === 'BinaryExpression' || node.right.type === 'LogicalExpression') && (0, isHigherBinaryOperatorOrder_js_1.isHigherOperatorOrder)(node.operator, node.right.operator)) {
        node.right.needParen = true;
    }
    var right = tersifyAcornNode(context, node.right, length);
    return node.needParen ?
        "(".concat(left, " ").concat(node.operator, " ").concat(right, ")") :
        "".concat(left, " ").concat(node.operator, " ").concat(right);
}
function tersifyNewExpressionNode(context, node, length) {
    return tersifyNewDate(node) || "new ".concat(tersifyAcornNode(context, node.callee, length), "(").concat(node.arguments.map(function (a) { return tersifyAcornNode(context, a, length); }).join(', '), ")");
}
function tersifyNewDate(node) {
    if (node.callee.type === 'Identifier' && node.callee.name === 'Date') {
        var args = node.arguments;
        if (args.length > 0) {
            var hasNotLiteralArgs = args.some(function (a) { return a.type !== 'Literal'; });
            if (!hasNotLiteralArgs) {
                var literalArgs = args;
                if (literalArgs.length === 1) {
                    var arg = literalArgs[0];
                    if (typeof arg.value === 'string') {
                        var date_1 = new Date(arg.value);
                        return date_1.toISOString();
                    }
                }
                // Assuming all arguments are numbers
                var dateArgs = literalArgs.map(function (a) { return a.value; });
                var date = new (Date.bind.apply(Date, __spreadArray([void 0], dateArgs, false)))();
                return date.toISOString();
            }
        }
    }
}
function tersifyVariableDeclaratorNode(context, node, length) {
    return "".concat(node.id.name).concat(node.init ? " = ".concat(tersifyAcornNode(context, node.init, length)) : '');
}
function tersifyVariableDeclarationNode(context, node, length) {
    return "".concat(node.kind, " ").concat(node.declarations.map(function (d) { return tersifyAcornNode(context, d, length); }).join(', '));
}
function tersifyIdentifierNode(context, node, _length) {
    return node.name === 'Symbol' ? 'Sym' : node.name;
}
function tersifyLiteralNode(context, node, _length) {
    return node.raw;
}
function tersifyRestElementNode(context, node, _length) {
    return "...".concat(node.argument.name);
}
function tersifyAssignmentPatternNode(context, node, length) {
    var eq = ' = ';
    return "".concat(node.left.name).concat(eq).concat(tersifyAcornNode(context, node.right, length - node.left.name.length - eq.length));
}
function tersifyArrowExpressionNode(context, node, length) {
    var async = node.async ? 'async ' : '';
    var generator = node.generator ? '*' : '';
    var arrow = " => ";
    var skipParamParen = node.params.length === 1 && node.params[0].type !== 'ObjectPattern';
    var paramsBody = tersifyParamsBody(context, node.params);
    var params = skipParamParen ? paramsBody : "(".concat(paramsBody, ")");
    var singleBodyNode = getSingleStatementBodyNode(context, node.body);
    var body = singleBodyNode ?
        tersifyArrowBodyAsSingleStatement(context, singleBodyNode) :
        tersifyFunctionBody(context, node.body);
    var isSingleBodyObjectExpression = singleBodyNode && singleBodyNode.type === 'ObjectExpression';
    if (isSingleBodyObjectExpression) {
        body = "(".concat(body, ")");
    }
    if (async.length + generator.length + params.length + arrow.length + body.length <= length) {
        return "".concat(async).concat(generator).concat(params).concat(arrow).concat(body);
    }
    else {
        var lenAvailForParams = Math.max(skipParamParen ? 1 : 3, length - (async.length + generator.length + arrow.length + body.length));
        var trimmedParams = skipParamParen ?
            (0, trim_js_1.trim)(context, paramsBody, lenAvailForParams) :
            "(".concat((0, trim_js_1.trim)(context, paramsBody, lenAvailForParams - 2), ")");
        if (async.length + generator.length + lenAvailForParams + arrow.length + body.length <= length) {
            return "".concat(async).concat(generator).concat(trimmedParams).concat(arrow).concat(body);
        }
        else {
            var minBodyLen = 3;
            var wrapLen = isSingleBodyObjectExpression ?
                "({  })".length :
                singleBodyNode ? 0 : "{  }".length;
            var lenAvailForBody = Math.max(minBodyLen, length - (async.length + generator.length + trimmedParams.length + arrow.length + wrapLen));
            var trimmedBody = isSingleBodyObjectExpression ?
                "({ ".concat((0, trim_js_1.trim)(context, body.slice(2, body.length - 2), lenAvailForBody - 4), " })") :
                singleBodyNode ?
                    (0, trim_js_1.trim)(context, body, lenAvailForBody) :
                    "{ ".concat((0, trim_js_1.trim)(context, body.slice(2, body.length - 1), lenAvailForBody), " }");
            return (0, trim_js_1.trim)(context, "".concat(async).concat(generator).concat(trimmedParams).concat(arrow).concat(trimmedBody), length);
        }
    }
}
function getSingleStatementBodyNode(context, node) {
    if (node.type !== 'BlockStatement')
        return node;
    if (node.body.length === 1 && node.body[0].type === 'ReturnStatement')
        return node.body[0];
    return undefined;
}
function tersifyArrowBodyAsSingleStatement(context, node) {
    if (node.type === 'ReturnStatement') {
        if (!node.argument)
            return "{}";
        if (node.argument.type === 'ObjectExpression') {
            return "(".concat(tersifyAcornNode(context, node.argument, Infinity), ")");
        }
        return tersifyAcornNode(context, node.argument, Infinity);
    }
    return tersifyAcornNode(context, node, Infinity);
}
function tersifyExpressionStatementNode(context, node, length) {
    return tersifyAcornNode(context, node.expression, length);
}
function tersifyMemberExpressionNode(context, node, length) {
    var property = node.property.type === 'Identifier'
        ? tersifyAcornNode(context, node.property, length)
        : "[".concat(tersifyAcornNode(context, node.property, length), "]");
    return "".concat(tersifyAcornNode(context, node.object, length)).concat(node.optional ? '?' : '', ".").concat(property);
}
function tersifyCallExpressionNode(context, node, length) {
    if (isSymbolForNode(node)) {
        return "Sym(".concat(node.arguments[0].value, ")");
    }
    if (isDefineThisProperty(node)) {
        var prop = node.arguments[1].value;
        return "this.".concat(prop, " = ").concat(tersifyAcornNode(context, node.arguments[2], length - 5 - prop.length - 3));
    }
    var callee = tersifyAcornNode(context, node.callee, length);
    var params = tersifyFunctionParams(context, node.arguments);
    return "".concat(callee).concat(node.optional ? '?.' : '').concat(params);
}
function isSymbolForNode(node) {
    return node.callee.type === 'MemberExpression' &&
        node.callee.object.type === 'Identifier' &&
        node.callee.object.name === 'Symbol' &&
        node.callee.property.type === 'Identifier' &&
        node.callee.property.name === 'for';
}
function isDefineThisProperty(node) {
    return node.callee.type === 'Identifier' &&
        node.callee.name === '_defineProperty' &&
        node.arguments.length === 3 &&
        node.arguments[0].type === 'ThisExpression';
}
function tersifyParamsBody(context, params) {
    return params.reduce(function (p, v) {
        p.push(tersifyAcornNode(context, v, Infinity));
        return p;
    }, []).join(', ');
}
function tersifyFunctionExpressionNode(context, node, length) {
    var token = context.raw ? "function" : 'fn';
    var async = node.async ? 'async ' : '';
    var generator = node.generator ? '*' : '';
    var id = node.id ? " ".concat(node.id.name) : '';
    var params = node.params.length > 0 ? tersifyFunctionParams(context, node.params) : '()';
    var space = ' ';
    var declarationLen = async.length + token.length + generator.length + id.length + space.length;
    var paramsContent = params.slice(1, params.length - 1);
    var minParam = paramsContent.length > 3 ? "(".concat((0, trim_js_1.trim)(context, paramsContent, 3), ")") : params;
    var minPrebodyLen = declarationLen + minParam.length;
    var prebodyLen = declarationLen + params.length;
    var body = tersifyFunctionBody(context, node.body);
    if (minPrebodyLen + body.length > length) {
        // 5 = length of `{ . }` to indicate there are something in the body
        if (minPrebodyLen + 5 > length) {
            return (0, trim_js_1.trim)(context, "".concat(async).concat(token).concat(generator).concat(id).concat(minParam).concat(space).concat(body), length);
        }
        else {
            var bodyContent = body.slice(2, body.length - 2);
            var result = "".concat(async).concat(token).concat(generator).concat(id).concat(minParam).concat(space).concat(bodyContent.length === 0 ?
                '{}' :
                "{ ".concat((0, trim_js_1.trim)(context, bodyContent, length - minPrebodyLen - 4), " }"));
            return result.length > length ? (0, trim_js_1.trim)(context, result, length) : result;
        }
    }
    else if (prebodyLen + body.length > length) {
        if (minPrebodyLen + body.length < length) {
            return "".concat(async).concat(token).concat(generator).concat(id, "(").concat((0, trim_js_1.trim)(context, paramsContent, length - body.length - declarationLen - 2), ")").concat(space).concat(body);
        }
        return (0, trim_js_1.trim)(context, "".concat(async).concat(token).concat(generator).concat(id).concat(minParam).concat(space).concat(body), length);
    }
    else {
        return (0, trim_js_1.trim)(context, "".concat(async).concat(token).concat(generator).concat(id).concat(params).concat(space).concat(body), length);
    }
}
function tersifyFunctionParams(context, params) {
    return "(".concat(tersifyParamsBody(context, params), ")");
}
function tersifyFunctionBody(context, value) {
    return tersifyAcornNode(context, value, Infinity);
}
function tersifyBlockStatementNode(context, node, length) {
    if (length <= 3 && node.body.length > 0)
        return (0, trim_js_1.trim)(context, '...', length);
    if (length <= 4 && node.body.length > 0)
        return (0, trim_js_1.trim)(context, '{...', length);
    var bracketAndSpaceLength = 4;
    var bodyLen = length - bracketAndSpaceLength;
    var statements = [];
    node.body.forEach(function (n) {
        if (bodyLen) {
            var s = tersifyAcornNode(context, n, bodyLen);
            bodyLen -= s.length;
            if (s && s !== 'return')
                statements.push(s);
        }
    });
    var body = statements.join('; ');
    var result = "{".concat(body ? " ".concat(body, " ") : '', "}");
    return result;
}
function tersifyReturnStatementNode(context, node, length) {
    if (!node.argument)
        return 'return';
    return "return ".concat(tersifyAcornNode(context, node.argument, length));
}
function tersifyThisExpression(_context, _node, _length) {
    return "this";
}
function tersifyClassExpression(context, node, length) {
    var classStr = (0, trim_js_1.trim)(context, "class".concat(node.id ? " ".concat(node.id.name) : ' ', "{}"), length);
    var prefix = classStr.slice(0, Math.max(3, classStr.length - 2));
    var body = tersifyAcornNode(context, node.body, length - prefix.length);
    return "".concat(prefix).concat(length >= prefix.length + body.length || body.length > 3 ? body : (0, trim_js_1.trim)(context, '...', length - prefix.length));
}
function tersifyMethodDefinition(context, node, length) {
    var _a;
    var staticStr = node.static ? 'static ' : '';
    var fnExpNode = node.value;
    var async = fnExpNode.async ? 'async ' : '';
    var generator = fnExpNode.generator ? '*' : '';
    var id = (_a = node.key.name) !== null && _a !== void 0 ? _a : "[".concat(tersifyAcornNode(context, node.key, length), "]");
    var params = fnExpNode.params.length > 0 ? tersifyFunctionParams(context, fnExpNode.params) : '()';
    var space = ' ';
    var declarationLen = staticStr.length + async.length + generator.length + id.length + space.length;
    var paramsContent = params.slice(1, params.length - 1);
    var minParam = paramsContent.length > 3 ? "(".concat((0, trim_js_1.trim)(context, paramsContent, 3), ")") : params;
    var minPrebodyLen = declarationLen + minParam.length;
    var prebodyLen = declarationLen + params.length;
    var body = tersifyFunctionBody(context, fnExpNode.body);
    if (minPrebodyLen + body.length > length) {
        // 5 = length of `{ . }` to indicate there are something in the body
        if (minPrebodyLen + 5 > length) {
            return (0, trim_js_1.trim)(context, "".concat(staticStr).concat(async).concat(generator).concat(id).concat(minParam).concat(space).concat(body), length);
        }
        else {
            var bodyContent = body.slice(2, body.length - 2);
            var result = "".concat(staticStr).concat(async).concat(generator).concat(id).concat(minParam).concat(space).concat(bodyContent.length === 0 ?
                '{}' :
                "{ ".concat((0, trim_js_1.trim)(context, bodyContent, length - minPrebodyLen - 4), " }"));
            return result.length > length ? (0, trim_js_1.trim)(context, result, length) : result;
        }
    }
    else if (prebodyLen + body.length > length) {
        if (minPrebodyLen + body.length < length) {
            return "".concat(staticStr).concat(async).concat(generator).concat(id, "(").concat((0, trim_js_1.trim)(context, paramsContent, length - body.length - declarationLen - 2), ")").concat(space).concat(body);
        }
        return (0, trim_js_1.trim)(context, "".concat(staticStr).concat(async).concat(generator).concat(id).concat(minParam).concat(space).concat(body), length);
    }
    else {
        return (0, trim_js_1.trim)(context, "".concat(staticStr).concat(async).concat(generator).concat(id).concat(params).concat(space).concat(body), length);
    }
}
function tersifyObjectPattern(context, node, length) {
    return "".concat((0, trim_js_1.trim)(context, "{ ".concat(node.properties.map(function (p) { return tersifyAcornNode(context, p, length); }).join(', '), " }"), length - 2));
}
function tersifySequenceExpression(context, node, length) {
    return "(".concat(node.expressions.map(function (n) { return tersifyAcornNode(context, n, length); }).join(', '), ")");
}
function tersifyTemplateLiteral(context, node, length) {
    var elements = node.expressions.concat(node.quasis).sort(function (a, b) { return a.start - b.start; });
    return '`' + elements.reduce(function (p, e) {
        if (length <= 0)
            return p;
        if (e.type === 'TemplateElement') {
            length -= e.value.raw.length;
            p += e.value.raw;
        }
        else {
            var result = tersifyAcornNode(context, e, length);
            length -= result.length;
            p += '${' + result + '}';
        }
        return p;
    }, '') + '`';
}
function tersifyTaggedTemplateExpression(context, node, length) {
    var name = node.tag.name;
    return name + tersifyAcornNode(context, node.quasi, length - name.length);
}
function tersifyChainExpression(context, node, length) {
    switch (node.expression.type) {
        case 'MemberExpression':
            return tersifyMemberExpressionNode(context, node.expression, length);
        // return `${tersifyAcornNode(context, node.expression.object, length)}?.${tersifyAcornNode(context, node.expression.property, length)}`
        case 'CallExpression': {
            return tersifyCallExpressionNode(context, node.expression, length);
        }
        // istanbul ignore next
        default:
            return tersifyUnknown(node);
    }
}
//# sourceMappingURL=tersifyAcorn.js.map